import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { ResultRequestModel } from "../models/resultRequest.model";
import { HttpService } from "./http.service";

const basePath = "/Dashboard";
const request = HttpService.handleRequest();

export const DashboardService = {
  getAll,
  getList,
  equipmentPickup,
  equipmentMonit,
  equipmentCacheReset ,// sprint 22  - 8336 - Reset do Cache
  daysReport, // sprint 23 - Relatorio agendado
  setequipmentextractionprogressexcel
};

async function getAll() {
  return request.get(basePath);
}

async function getList(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/ForecastListWithPagination`, data);
}

async function equipmentMonit(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/ForecastEquipmentMonit`, data);
}

async function equipmentPickup(data: RequestInputOutputParamsModel) {
  return request.put(`${basePath}/EquipmentPickup`, data);
}

// sprint 22  - 8336 - Reset do Cache
async function equipmentCacheReset(data: RequestInputOutputParamsModel) {
  return request.put(`${basePath}/EquipmentCacheReset`,data);
}
// sprint 22  - 8336 - Reset do Cache
// sprint 23 - Relatorio agendado
async function daysReport() {
  return request.get(`${basePath}/ListDaysReport`);
}
// sprint 23 - Relatorio agendado

// sprint 22  - 8336 - Reset do Cache
async function setequipmentextractionprogressexcel(data: RequestInputOutputParamsModel) {
  return request.put(`${basePath}/SetEquipmentExtractionProgressExcel`,data);
}
export default DashboardService;